import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { Switch } from '../ui/switch';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

const ITEMS = [
  ['reminders', 'Event & class reminders', '24 hours and 1 hour before things you registered for'],
  ['live', 'Live now alerts', 'When a satsang or live session starts'],
  ['community', 'Community replies & likes', 'When someone comments on or likes your post'],
];

export const NotificationPrefs = () => {
  const { toast } = useToast();
  const [prefs, setPrefs] = useState(null);
  useEffect(() => { api.get('/notifications/prefs').then((r) => setPrefs(r.data)).catch(() => {}); }, []);
  const toggle = async (k, v) => {
    const next = { ...prefs, [k]: v };
    setPrefs(next);
    try { await api.put('/notifications/prefs', next); } catch { toast({ title: 'Could not save' }); setPrefs(prefs); }
  };
  if (!prefs) return null;
  return (
    <section className="mt-10 bg-white/70 rounded-3xl border border-rose/40 p-6" data-testid="notification-prefs">
      <h2 className="font-serif-display text-2xl text-burgundy flex items-center gap-2"><Bell className="w-5 h-5 text-rose-italic" /> Notifications</h2>
      <p className="text-sm text-mahogany/70 mt-1">Choose what we send to the app and your notification bell. Registration confirmations and messages from Osho Universal are always delivered.</p>
      <div className="mt-4 divide-y divide-rose/25">
        {ITEMS.map(([k, label, hint]) => (
          <label key={k} className="flex items-center justify-between gap-4 py-3 cursor-pointer">
            <span><span className="block text-burgundy">{label}</span><span className="block text-xs text-mahogany/60">{hint}</span></span>
            <Switch checked={!!prefs[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`pref-${k}`} />
          </label>
        ))}
      </div>
    </section>
  );
};

export default NotificationPrefs;
